"use strict";const i=require("styled-components").css`
    &.DXCustomerJourneyDiamond {
        position: relative;
        width: 100%;

        .DSCustomerJourneyDiamond-container {
            position: relative;
            width: 100%;
            max-width: 1058px;
            margin: 0 auto;
            display: flex;
            flex-wrap: nowrap;
            z-index: 2;
            padding: 0px 20px;
            box-sizing: border-box;
            @media (max-width: 920px) {
                flex-wrap: wrap;
            }
            @media (max-width: 750px) {
                padding-bottom: 50px;
            }
        }
        .DSCustomerJourneyDiamond-intro-content {
            position: relative;
            flex: 0 0 240px;
            margin-right: 20px;
            padding-right: 20px;
            /* padding-left: 20px; */
            @media (min-width: 751px) {
                border-top: 1px solid #ecedef;
            }

            @media (max-width: 980px) {
                flex: 0 0 180px;
                margin-right: 10px;
                padding-right: 10px;
            }
            @media (max-width: 920px) {
                flex: 0 0 100%;
                max-width: 440px;
                margin-bottom: 40px;
            }
        }
        .DXCustomerJourneyDiamond-heading {
            font-family: 'source-sans-pro';
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            letter-spacing: -0.3px;
            color: #25292d;
            margin-top: 15px;
            margin-bottom: 25px;
            @media (max-width: 750px) {
                margin-top: 10px;
                margin-bottom: 15px;
            }
        }
        .DXCustomerJourneyDiamond-subheading {
            p {
                font-family: 'source-sans-pro';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 27px;
                margin: 0px 0px 10px;
                color: #4e5255;
                @media (max-width: 750px) {
                    margin: 0px 0px 6px;
                }
            }
        }
        .DSCustomerJourneyDiamond-diamond {
            position: relative;
            flex: 1 1 100%;
            display: flex;
            gap: 10px;
            flex-direction: row;
            flex-wrap: wrap;

            @media (max-width: 750px) {
                display: none;
            }

            .diamond-graphic {
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                margin: auto;
                z-index: 1;
                @media (max-width: 750px) {
                    display: none;
                }
            }
        }
    }

    .DXCustomerJourneyDiamond-card-deck {
        position: relative;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0px 0px 40px;
    }
    #deck {
        scroll-snap-type: x mandatory;
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        align-items: center;
        -webkit-overflow-scrolling: touch;
        max-width: calc(100vw - 60px);
        position: relative;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
    #deck::-webkit-scrollbar {
        display: none;
    }

    .deck-box {
        position: relative;
        background: #ffffff;
        box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        width: 100%;
        overflow: hidden;
        padding-top: 100px;
        margin-top: -100px;
        padding-bottom: 50px;
    }
    .DXCustomerJourneyDiamond-card {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background: white;
        flex: 0 0 calc(50% - 5px);
        flex-direction: column;
        padding: 20px;
        text-align: center;
        box-sizing: border-box;
        @media (min-width: 751px) {
            aspect-ratio: 1 / 0.8;
            background: #ecedef;
        }
        @media (max-width: 750px) {
            scroll-snap-align: center;
            flex: 1 0 100%;
        }

        .inner-box {
            position: relative;
            width: 216px;
            @media (max-width: 750px) {
                width: 100%;
                max-width: 300px;
            }
        }
        &:nth-child(1) {
            .inner-box {
                margin-top: -10%;
                margin-left: -10%;
                @media (max-width: 1030px) {
                    margin-top: -15%;
                    margin-left: -15%;
                }
                @media (max-width: 750px) {
                    margin: 0;
                }
            }
        }
        &:nth-child(2) {
            .inner-box {
                margin-top: -10%;
                margin-left: 10%;
                @media (max-width: 1030px) {
                    margin-top: -15%;
                    margin-left: 15%;
                }
                @media (max-width: 750px) {
                    margin: 0;
                }
            }
        }
        &:nth-child(3) {
            .inner-box {
                margin-top: 10%;
                margin-left: 10%;
                @media (max-width: 1030px) {
                    margin-top: 15%;
                    margin-left: 15%;
                }
                @media (max-width: 750px) {
                    margin: 0;
                }
            }

            @media (min-width: 751px) {
                order: 4;
            }
        }
        &:nth-child(4) {
            .inner-box {
                margin-top: 10%;
                margin-left: -10%;
                @media (max-width: 1030px) {
                    margin-top: 15%;
                    margin-left: -15%;
                }
                @media (max-width: 750px) {
                    margin: 0;
                }
            }
            @media (min-width: 751px) {
                order: 3;
            }
        }
        .label {
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            line-height: 18px;
            margin: 5px 0px;
            @media (max-width: 750px) {
                font-size: 25px;
                line-height: 18px;
                letter-spacing: -0.271994px;
                margin-bottom: 20px;
            }
        }
        .content {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            margin: 0;
        }
    }

    .DXCustomerJourneyDiamond-header {
        margin-bottom: 20px;
    }
    #QuadrantMobileIcon {
        position: relative;
        z-index: 4;
        max-width: 100%;
    }
    #QuadrantMobileIcon path {
        transition: 0.2s;
    }
    .deck-navigation {
        display: flex;
        justify-content: center;
        gap: 50px;
        position: relative;
        span {
            cursor: pointer;
        }
    }
    @media (max-width: 750px) {
        &.DXCustomerJourneyDiamond::after {
            display: flex;
            position: absolute;
            background: #0075c9;
            bottom: 0;
            height: 300px;
            width: 100%;
            left: 0;
            right: 0;
            content: '';
            z-index: 0;
        }
    }
    .inactive-btn {
        svg path {
            fill: #dadada;
        }
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
